module.exports = __webpack_public_path__ + "img/documentacao.58454d5d.jpg";